import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  uploadDocToQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/upload/doc-to-quiz`,
  },
  uploadPptPdf: {
    method: 'POST',
    url: `${configs.baseUrl}/api/upload/file-document/v2`,
  },
  uploadXlsx: {
    method: 'POST',
    url: `${configs.baseUrl}/api/upload/xlsx`,
  },
  importSpreadsheet: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/import-sheet/`,
  },
  importSpreadsheetV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation/import-sheet/v2`,
  },
  uploadAudio: {
    method: 'POST',
    url: `${configs.baseUrl}/api/upload/file-audio/{presentationId}`,
  },
  uploadImageV2: {
    method: 'POST',
    url: `${configs.baseUrl}/api/upload/image/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const uploadDocToQuiz = (params) => {
  return resource.uploadDocToQuiz(params)
}

const uploadPptPdf = (params) => {
  return resource.uploadPptPdf(params)
}

const uploadXlsx = (params) => {
  return resource.uploadXlsx(params)
}

const importSpreadsheet = (params) => {
  return resource.importSpreadsheet(params)
}

const importSpreadsheetV2 = (params) => {
  return resource.importSpreadsheetV2(params)
}

const uploadAudio = (presentationId, params) => {
  return resource.uploadAudio({ presentationId }, params)
}

const uploadImageV2 = (params) => {
  return resource.uploadImageV2(params)
}

export default {
  initResource,
  uploadDocToQuiz,
  uploadPptPdf,
  uploadXlsx,
  importSpreadsheet,
  importSpreadsheetV2,
  uploadAudio,
  uploadImageV2,
}
